<template>
  <div>
    <el-tabs v-if="tabs.length > 0" class="tabs" v-model="selectPath" type="card" closable @tab-remove="removeTab"
      @tab-click="clicktab">

      <el-tab-pane v-for="(item, index) in tabs" :key="item.name" :label="item.name" :name="item.path">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    return {
      activePath: ''
    }
  },
  methods: {
    ...mapMutations('role', ['changedefaultPatch']),
    clicktab(e) {
      this.$router.push(e._props.name)
      this.changedefaultPatch(e._props.name)
    },
    removeTab(targetName) {
      let arr = this.tabs
      arr.forEach((item, index) => {
        if (item.path == targetName) {
          arr.splice(index, 1)
        }
      })
      sessionStorage.setItem('tabsList', JSON.stringify(arr));
    },
  },
  watch: {
    // 监听 selectPath 的变化
    defaultPatch(newVal, oldVal) {
      this.activePath = newVal
    },
    'tabMaxWidth': {
      immediate: true,
      handler(newVal) {
        console.log('实时宽度', newVal)
      }
    },
  },
  computed: {
    ...mapState('role', ['nickname', 'tabs', 'defaultPatch']),
    selectPath: {
      get() {
        return this.activePath
      },
      set(v) {
        this.activePath = v
      }
    }
  },
  created() {
    this.activePath = JSON.parse(JSON.stringify(this.defaultPatch))
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  min-width: 300px;
  max-width: 1100px;
  // flex: 1;
  // height: 50px;
  // overflow: hidden;
  // width: 1300px;
  // margin-left: 20px;
  // position: relative;
  // top: 4px;
  // border: red solid 1px;
}

::v-deep .el-tabs--card>.el-tabs__header {
  border-top: none;
}

::v-deep .el-tabs--card>.el-tabs__header {
  margin: 0;
  /* 覆盖默认的 0 0 16px 0 */
}
</style>